import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../Components/Utility/Loader/Loader';
import * as action from '../Store/PurchaseOrder.action';
import { PoLogList } from './PoLogList';

function PurchaseOrderLog() {
  const { devOrderId, orderPoId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    loader: false,
  });

  const locaStates = location?.state;
  const list = locaStates?.list;

  useEffect(() => {
    const callFn = async () => {
      const reqObj = {
        orderPoId,
      };
      setState((prevState) => ({ ...prevState, loader: true }));
      const res = dispatch(action.fetchPurchaseOrderLog(devOrderId, reqObj));
      if (res) setState((prevState) => ({ ...prevState, loader: false }));
    };
    if (!isEmpty(devOrderId) && !isEmpty(orderPoId)) callFn();
  }, [devOrderId, orderPoId, dispatch]);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('PURCHASE_ORDER_LOG.INDEX.PURCHASE_LOG')}</h4>
        </div>
        <div className="search-filter">
          <Link
            className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib"
            to={
              list
                ? `/development-order/${devOrderId}/order-po-template/${orderPoId}?list=${list}`
                : `/development-order/${devOrderId}/order-po-template/${orderPoId}`
            }
          >
            {t('PURCHASE_ORDER_LOG.INDEX.BACK')}
          </Link>
        </div>
      </div>
      <div className="pt-4">
        <Container fluid className="px-3">
          {state.loader ? <Loader /> : <PoLogList />}
        </Container>
      </div>
    </>
  );
}

export default PurchaseOrderLog;
